import LMSDispatcher from "../../LMSDispatcher";
import { EventEmitter } from "events";

import ILogViewData from "../../../models/logs/LogViewData";
import * as ACTIONCONSTANTS from "../../actions/ActionConstants";

interface ILogList {
  state: {
    logDataList?: ILogViewData[];
  };
}

class ListStore extends EventEmitter implements ILogList {
  state: {
    logDataList?: ILogViewData[] | undefined;
  };
  constructor() {
    super();
    this.state = {
      logDataList: [],
    };
    LMSDispatcher.register((e: any) => {
      switch (e.type) {
        case ACTIONCONSTANTS.LOG_GET_ALL:
          Object.assign(this.state, e.payload);
          this.emit("change", this.state);
          break;
      }
    });
  }
}

const logListStore = new ListStore();

export default logListStore;
